import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';

import Breadcrumb from '../../Components/Common/Modules/Breadcrumb';
import Toast from '../../Components/Common/Modules/Toast';
import LoadingSpinner from '../../Helpers/LoadingSpinner';
import Text from '../../Components/Common/Text/Text';
import Link from '../../Components/Common/Atoms/Link';
import TitleWeb from '../../Components/Common/Web/Title';
import IncentivarVincularClubBanner from '../../Components/Common/Banners/IncentivarVincularClub';
import IncentivarSuscripcionBanner from '../../Components/Common/Banners/IncentivarSuscripcion';
import MiniCards from '../../Components/Common/Atoms/MiniCards';
import Modal from '../../Components/Common/Organism/Modal';
import Button from '../../Components/Common/Modules/Button';
import CredentialCardBox from '../../Components/Common/Modules/CredentialCardBox';
import IconList from '../../Statics/Imgs/listIcon';
import useObtenerGrupos from '../../Hooks/useObtenerGrupos';
import useDarDeBajaCredencial from '../../Hooks/useDarDeBajaCredencial';
import useObtenerCredenciales from '../../Hooks/useObtenerCredenciales';
import CardCredencialesPendientesDeOtorgar from '../../Components/Features/MisCredenciales/CardCredencialesPendientesDeOtorgar';
import '../../Statics/Scss/Pages/MisCredenciales.scss';
import PathsConfig from '../../Config/RoutePaths';
import CargaHistorial from '../../Components/Features/MisCredenciales/CargarHistorial';
import useObtenerRelacionClub from '../../Hooks/useObtenerRelacionClub';
import useListarEventos from '../../Hooks/useListarEventos';
import { EstadosCredencial } from '../../Config/EstadoCredencial';
import { SituacionDeEntregaCredencial } from '../../Config/SituacionEntregaCredencial';
import useObtenerVerificacionCredenciales from '../../Hooks/useObtenerVerificacionCredenciales ';
import { ToastBloqueoCredenciales } from './../../Components/Common/Banners/ToastBloqueoCredenciales';

const MisCredenciales = () => {
    const history = useHistory();
    const [openModal, setOpenModal] = useState(false);
    const [showHistorial, setShowHistorial] = useState(false);
    const [gruposObtenidos, credencialesOtorgadas, errorGrupos, isLoadingGrupos] = useObtenerGrupos();
    const [credencialSeleccionada, setCredencialSeleccionada] = useState();
    const [darDeBaja, errorBaja, isLoadingBaja] = useDarDeBajaCredencial();
    const [credenciales, errorCredenciales, isLoadingCredenciales] = useObtenerCredenciales();
    const [dataRelacionClub, errorRelacionClub, isLoadingRelacion] = useObtenerRelacionClub();
    const [historial, errorHistorial, isLoadingHistorial, getHistorial] = useListarEventos();
    const [isBlockedCredenciales, errorVerificacionCredenciales, isLoadingVerificacionCredenciales] = useObtenerVerificacionCredenciales();

    const onDetalles = () => {
        if (!errorHistorial && !historial) getHistorial();
        setShowHistorial(!showHistorial);
    };

    const handleBajaCredencial = async (credencial) => {
        let idTitular = credencial.CrmidTitular;
        let idCredencial = credencial.Crmid;
        let nroCredencial = credencial.NumeroCredencial;
        let tipoCredencial = dataRelacionClub?.response?.categoria;
        if (credencial) {
            darDeBaja(idTitular, idCredencial, nroCredencial, tipoCredencial)
                .then((success) => {
                    history.push({
                        pathname: PathsConfig.MisCredencialesSolicitudDeBaja,
                        state: {
                            credencial: credencial,
                            success: success,
                        },
                    });
                })
                .catch(() => {
                    history.push({
                        pathname: PathsConfig.MisCredencialesSolicitudDeBaja,
                        state: {
                            credencial: credencial,
                        },
                    });
                });
        }
        setOpenModal(false);
    };

    const onClickReclamar = (credencial) => {
        history.push({
            pathname: PathsConfig.ReclamoTarjeta,
            state: {
                CredencialPreSelected: credencial,
            },
        });
    }

    const noTieneCredencialDeCortesia = (credenciales) => {
        // si el grupo obtenido tiene TipoDeCortesia de tipo string
        return !credenciales?.some(i => i.GrupoCredencial?.IdTipoDeCortesia !== null);
    };

    const noTieneCredenciales = (credenciales) => {
        return credenciales === null || !credenciales.length;
    }


    return (
        <>
            <section>
                <Breadcrumb firstItem="Club LA NACION" text="Mis credenciales" href="#" />
                <TitleWeb text="Mis credenciales" />
            </section>

            <section className="container-streched">
                <LoadingSpinner isLoading={isLoadingBaja || isLoadingGrupos || isLoadingCredenciales || isLoadingRelacion || isLoadingVerificacionCredenciales}>
                    {errorCredenciales || errorGrupos || errorRelacionClub || errorBaja || errorVerificacionCredenciales ? (
                        <Toast status="warning" title="Ocurrió un error">
                            Hubo un problema al consultar tus credenciales. Por favor, intentalo de nuevo.
                        </Toast>
                    ) : (
                        <div className="mis-credenciales-body">

                            {isBlockedCredenciales ?
                                <ToastBloqueoCredenciales title={"Atención"} estado={"alert"} subtitle={"La gestión de tus credenciales está temporalmente suspendida."}/>
                                : (
                                    <>
                                        {noTieneCredenciales(credenciales) &&
                                            noTieneCredencialDeCortesia(credenciales) &&
                                            !credencialesOtorgadas ?
                                            <>
                                                <Toast status="info" title="No tenés credenciales disponibles"></Toast>
                                                <IncentivarVincularClubBanner showBottomDivider />
                                                <IncentivarSuscripcionBanner showBottomDivider />
                                            </> :
                                            <>
                                                {openModal && (
                                                    <Modal closeModal={() => setOpenModal(false)}>
                                                        <Text tag="p" size="2xs" font="arial">
                                                            Estás por eliminar la credencial Nro. <strong>{credencialSeleccionada.NumeroCredencial}</strong> de{' '}
                                                            <strong>{credencialSeleccionada.NombreTitular}</strong>. Al confirmar, podrás asignar la credencial a otra persona.{' '}
                                                            Recordá que la baja de credencial no implica la baja de la suscripción.
                                                            <div>
                                                                <br />
                                                            </div>
                                                        </Text>
                                                        <div className="buttons-modal">
                                                            <Button label="Confirmar" onClick={() => handleBajaCredencial(credencialSeleccionada)} />
                                                            <Button label="Cancelar" onClick={() => setOpenModal(false)} mod={'tertiary'} />
                                                        </div>
                                                    </Modal>
                                                )}
                                                <CardCredencialesPendientesDeOtorgar gruposCredenciales={gruposObtenidos} />
                                                <Text tag="p" size="--s" font="arial" weight="bold" className="mis-credenciales-text">
                                                    Credenciales otorgadas
                                                </Text>
                                                {!isLoadingGrupos &&
                                                    credencialesOtorgadas.map((cred, i) => (
                                                        <CredentialCardBox
                                                            key={i}
                                                            className="--mb-8"
                                                            nombre={cred.NombreTitular}
                                                            tipoDeCredencial={cred.CategoriaCredencial}
                                                            vigencia={`${cred.VigenciaDesde} - ${cred.VigenciaHasta}`}
                                                            domicilioDeEntrega={cred.DomicilioDetalle}
                                                            estadoCredencial={EstadosCredencial[cred.IdEstado]}
                                                            situacionDeEntrega={SituacionDeEntregaCredencial[cred.IdSituacionDeEntrega]}
                                                            nroDeCredencial={cred.NumeroCredencial}
                                                            onClickBaja={() => {
                                                                setOpenModal(true);
                                                                setCredencialSeleccionada(cred);
                                                            }}
                                                            onClickReclamar={() => onClickReclamar(cred)}
                                                        />
                                                    ))}
                                            </>}

                                        <div className="mis-credenciales-historial">
                                            <div className="historial">
                                                <IconList />

                                                <div className="">
                                                    <Text tag="p" size="2xs" font="arial" weight="bold">
                                                        Historial de movimientos
                                                    </Text>
                                                    <Link target="_blank" onClick={onDetalles}>
                                                        {showHistorial ? 'Ocultar detalle' : 'Ver detalle'}
                                                    </Link>
                                                </div>
                                            </div>
                                            {showHistorial && (
                                                <CargaHistorial historial={historial} errorHistorial={errorHistorial} isLoadingHistorial={isLoadingHistorial} />
                                            )}
                                        </div>

                                    </>
                                )}

                        </div>
                    )}
                </LoadingSpinner>
            </section>
        </>
    );
};

export default MisCredenciales;
